/* eslint-disable react/no-array-index-key */
import React from "react";
import PropTypes from "prop-types";
import "./css/genericText.css";

const GenericText = ({
  reply,
  addButtonResponse,
  scrollChatToBottom,
  showOverlay,
  fixMissingImage,
  logout,
  sendCartToDomDotCom /* START CORE-12106 */,
  backToBuilder,
  initiateBuilderChat /* END CORE-12106 */
}) => (
  <div data-quid="generic-text-template" className="template--generic-text">
    {reply.media[0].title && (
      <h1 data-quid="generic-title">{reply.media[0].title} </h1>
    )}
    {reply.media[0].description && <h3>{reply.media[0].description}</h3>}
    {reply.media[0].image && (
      <img
        src={reply.media[0].image}
        alt={reply.media[0].title}
        onLoad={scrollChatToBottom}
        onError={evt => fixMissingImage(evt)}
      />
    )}
    {reply.media.map((mediaElement, mediaIndex) => (
      <ul
        data-quid={`generic-media-${reply.template}-${mediaIndex}`}
        key={`media${mediaIndex}`}
      >
        {mediaElement.buttons
          ? mediaElement.buttons.map((button, index) => (
              <li
                key={`btn${mediaIndex}${index}`}
                className="template--button-group__reply test"
              >
                <button
                  data-quid={`generic-media-button-${
                    reply.template
                  }-${mediaIndex}${index}`}
                  type="button"
                  onClick={() => {
                    switch (button.type) {
                      case "account_link":
                        showOverlay("login", true);
                        break;
                      case "account_unlink":
                        logout();
                        break;
                      case "web_url":
                      case "deep_link":
                        sendCartToDomDotCom(
                          button.payload,
                          button.openInNewTab
                        );
                        break;
                      //START CORE-12106
                      case "back_to_builder":
                        backToBuilder();
                        break;
                      case "initiate_chat":
                        initiateBuilderChat();
                        break;
                      //END CORE-12106
                      default:
                        addButtonResponse(
                          button.title,
                          button.payload,
                          reply.title || mediaElement.title
                        );
                    }
                  }}
                >
                  {button.title}
                </button>
              </li>
            ))
          : ""}
      </ul>
    ))}
  </div>
);

GenericText.propTypes = {
  reply: PropTypes.shape({
    elements: PropTypes.arrayOf(PropTypes.object)
  }).isRequired,
  addButtonResponse: PropTypes.func.isRequired,
  scrollChatToBottom: PropTypes.func.isRequired,
  showOverlay: PropTypes.func,
  fixMissingImage: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  sendCartToDomDotCom: PropTypes.func /* START CORE-12106 */,
  backToBuilder: PropTypes.func,
  initiateBuilderChat: PropTypes.func /* END CORE-12106 */
};

GenericText.defaultProps = {
  showOverlay: null,
  sendCartToDomDotCom: null /* START CORE-12106 */,
  backToBuilder: null,
  initiateBuilderChat: null /* END CORE-12106 */
};

export default GenericText;
